import { render, staticRenderFns } from "./registerFoot.vue?vue&type=template&id=2706e1ff&scoped=true&"
import script from "./registerFoot.vue?vue&type=script&lang=js&"
export * from "./registerFoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706e1ff",
  null
  
)

export default component.exports